import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const initialState = {
  contact: null,
  fromAddress: null,
  fromLocation: null,
  method: null,
  shipment: null,
  toAddress: null,
  toLocation: null,
};
const ShipmentFormContext = createContext(initialState);

export const useShipmentFormContext = () => useContext(ShipmentFormContext);

const ShipmentFormProvider = ({ children, value }) => (
  <ShipmentFormContext.Provider value={value}>{children}</ShipmentFormContext.Provider>
);

ShipmentFormProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.object,
};

ShipmentFormProvider.defaultProps = {
  value: initialState,
};

export default ShipmentFormProvider;
